import PropTypes from 'prop-types';
import React from 'react';

import { withFormsy } from 'formsy-react';
import { SimpleAlert } from 'twyne-new.ui';

const propTypes = {
  color: PropTypes.string,
};

function Alert({ getErrorMessage, color }) {
  const errorMessage = getErrorMessage()

  if (!errorMessage) {
    return null
  }

  return <SimpleAlert variant={color}>
    {errorMessage}
  </SimpleAlert>
}

Alert.propTypes = propTypes
Alert.defaultProps = {}

export default withFormsy(Alert)
